import { render, staticRenderFns } from "./BasicPus.vue?vue&type=template&id=ae1f3eb4&"
import script from "./BasicPus.vue?vue&type=script&lang=ts&"
export * from "./BasicPus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports